import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

const UnSuspendPosModal = ({
  show,
  handleHide,
  title,
  text,
  confirmUnSuspension,
}) => {
  const { t: translator } = useTranslation();

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{text}</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("POS-DeleteModalButton-Close")}
        </button>
        <button
          onClick={confirmUnSuspension}
          type="button"
          className="btn btn-primary"
        >
          {translator("PosDetail-UnSuspendPos")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnSuspendPosModal;
